<template>
  <div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
      style="margin-top: 25px"
    >
      <h2>Refill Management</h2>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <v-divider></v-divider>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-form ref="form">
          <v-data-table
            :headers="headers"
            :items="product_list"
            :loading="table_loading"
            loading-text="Loading... Please wait"
            :mobile-breakpoint="0"
            hide-default-footer
            disable-sort
            disable-pagination
          >
            <template v-slot:[`item.image_url`]="props">
              <div>
                <div v-if="props.item.image_url != ''">
                  <img
                    width="60"
                    height="60"
                    :src="props.item.image_url"
                    alt="image"
                  />
                </div>
                <div v-else>
                  <p style="margin-bottom: 0">No Image</p>
                </div>
              </div>
            </template>
            <template v-slot:[`item.stock_in`]="props">
              <div style="width: 75px">
                <v-text-field
                  outlined
                  dense
                  v-model="props.item.stock_in"
                  hide-details="auto"
                  @keypress="only_for_number"
                  @paste.prevent
                  type="number"
                  :rules="[
                    () => !isNaN(props.item.stock_in) || 'Invalid input',
                    () =>
                      props.item.stock_in <= props.item.max_capacity ||
                      `Can't be larger than ${props.item.max_capacity}`,
                    () =>
                      Number(props.item.stock_in) >= 0 ||
                      'Must be larger than 0',
                  ]"
                ></v-text-field>
              </div>
            </template>
            <template v-slot:[`item.stock_out`]="props">
              <div style="width: 75px">
                <v-text-field
                  outlined
                  dense
                  v-model="props.item.stock_out"
                  hide-details="auto"
                  @keypress="only_for_number"
                  @paste.prevent
                  type="number"
                  :rules="[
                    () => !isNaN(props.item.stock_out) || 'Invalid input',
                    () =>
                      props.item.stock_out <= props.item.max_capacity ||
                      `Can't be larger than ${props.item.max_capacity}`,
                    () =>
                      Number(props.item.stock_out) >= 0 ||
                      'Must be larger than 0',
                  ]"
                ></v-text-field>
              </div>
            </template>
          </v-data-table>
        </v-form>
      </v-card>
    </div>
    <div style="height: 150px"></div>
    <div style="position: fixed; left: 0; right: 0; width: auto; bottom: 0">
      <v-card
        min-height="100"
        style="padding-top: 10px"
        flat
        outlined
        :style="{
          paddingLeft: generalSpacingLeftRight + '%',
          paddingRight: generalSpacingLeftRight + '%',
        }"
      >
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <div class="ma-3">
            <v-btn
              style="text-transform: capitalize"
              outlined
              @click="full_stock_out"
              >Full Stock Out</v-btn
            >
          </div> -->
          <div class="ma-3">
            <v-btn
              depressed
              style="text-transform: capitalize"
              class="white--text"
              color="primary"
              :disabled="is_submitting"
              :loading="is_submitting"
              @click="update"
              >Save</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      headers: [
        { text: "Slot Label", value: "motor_label", divider: true },
        {
          text: "Stock In",
          value: "stock_in",
          divider: true,
          align: "center",
          width: 50,
        },
        {
          text: "Stock Out",
          value: "stock_out",
          divider: true,
          align: "center",
          width: 50,
        },
        {
          text: "Current Inventory",
          value: "inventory",
          divider: true,
          align: "center",
          width: 50,
        },
        { text: "Product SKU", value: "product_sku", divider: true },
        { text: "Product Name", value: "product_name", divider: true },
        { text: "Image", value: "image_url", divider: true, align: "center" },
        { text: "Max Capacity", value: "max_capacity", align: "center" },
      ],
      product_list: [],
      table_loading: false,
      is_submitting: false,
      current_user_permission: [],
      current_user_company_doc_id: "",
    };
  },
  methods: {
    full_stock_out() {
      this.product_list.forEach((item) => {
        item.stock_out = item.inventory;
      });
    },
    load_slot() {
      this.table_loading = true;
      console.log(
        "machine_id",
        this.$store.getters.getSelectedMachine.split(" - ")[0]
      );
      this.send_auth_http_request("getMachineSlot", {
        machine_id: this.$store.getters.getSelectedMachine.split(" - ")[0],
      })
        .then((response) => {
          this.table_loading = false;
          if (response.data.status == "OK") {
            this.product_list = response.data.result;
          }
        })
        .catch((error) => {
          console.log(error);
          this.table_loading = false;
        });
    },
    update() {
      if (this.$refs.form.validate()) {
        this.is_submitting = true;
        console.log("getUserID", this.$store.getters.getUserID);
        console.log("getUserName", this.$store.getters.getUserName);

        this.send_auth_http_request("updateMachineInventory", {
          machine_id: this.$store.getters.getSelectedMachine.split(" - ")[0],
          product_list: this.product_list,
        })
          .then((response) => {
            this.is_submitting = false;
            if (response.data.status == "OK") {
              this.show_snack_bar("success", "Inventory Updated");
              this.load_slot();
              this.$refs.form.resetValidation();
            } else {
              this.show_snack_bar("error", "Something went wrong");
            }
          })
          .catch((error) => {
            this.is_submitting = false;
            this.show_snack_bar("error", "Something went wrong");
          });
      }
    },
  },
  mounted() {
    this.load_slot();
  },
  async created() {
    await this.load_all_machines_basic_info();
    this.current_user_permission = this.$store.getters.getUserRoleList;
    this.current_user_company_doc_id = this.$store.getters.getUserCompanyDocId;
    // Update store
    var payload = {
      headerType: "needHeader",
      currentPage: "RefillServiceScreen",
    };
    this.$store.dispatch("updateHeaderType", payload);
    this.$store.dispatch("updateCurrentPage", payload);

    if (
      !this.current_user_permission.includes("Mi2PLUvyhPb7fgXOynEp") &&
      !this.current_user_permission.includes("R23iynu9Wz4du6IX50rK") &&
      !this.current_user_permission.includes("UsVr0wHOjW29JiLaIv0E")
    ) {
      this.$router.push({ name: "HomeScreen" }).catch((err) => {});
    }
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 5;
      }
    },
  },
};
</script>

<style>
</style>